export const US_TAX_FORMS = [
  // income
  '1040',
  '1040-SR',
  '1040-NR',
  '1040-X',
  'W-2',
  'W-2G',
  '1099-INT',
  '1099-DIV',
  '1099-MISC',
  '1099-NEC',
  '1099-G',
  '1099-R',
  'SSA-1099',
  '1099-B',
  '1099-K',
  'Schedule B (1040)',
  'Schedule C (1040)',
  'Schedule D (1040)',
  'Schedule E (1040)',
  'Schedule F (1040)',
  'K-1',

  // additional 1099s
  '1099-OID',
  '1099-C',
  '1099-S',
  '1099-PATR',

  // credits and deductions
  'Schedule A (1040)',
  '1095-A',
  '2441',
  '8863',
  '8880',
  '8889',
  '5695',
  '8396',
  '1040-ES',
  '1098',
  '1098-T',
  '1098-E',
  '5498',
  '5498-SA',
  '5498-ESA',
  '1099-SA',
  '1099-Q',

  // employment taxes
  '941',
  '940',
  'W-4',
  'W-9',
  '944',
  '945',

  // estate and gift taxes
  '706',
  '709',

  // excise taxes
  '720',
  '2290',

  // business taxes
  '1065',
  '1120',
  '1120-S',
  '990',

  // international
  '3520',
  '3520-A',
  '5471',
  '8865',
  '8938',

  // health insurance
  '1095-B',
  '1095-C',

  // miscellaneous
  '2848',
  '4506',
  '4506-T',
  '8822',
  '8829',

  // custom
  'Personal Property',
  'Real Estate',
];
